import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

const Signout = () => {
  const navigate = useNavigate();
  const { signOut } = useAuth();

  useEffect(() => {
    signOut();
    navigate("/user/login");
  });
  return <div></div>;
};

export default Signout;
